import React, { useState } from 'react';

import { Bars, Close } from '../../icons';
import { StyledButton } from './Hamburger.styles';
import { IHamburgerProps } from './Hamburger.types';

const Hamburger = ({
  active = false,
  ariaLabel = 'Open/close menu',
  onClick,
}: IHamburgerProps): JSX.Element => {
  const [open, setIsOpen] = useState<boolean>(active);
  const handleOnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setIsOpen(!open);
    onClick(e);
  };

  return (
    <StyledButton
      active={open}
      aria-expanded={open}
      aria-label={ariaLabel}
      onClick={e => handleOnClick(e)}
    >
      {open ? <Close /> : <Bars />}
    </StyledButton>
  );
};

export default Hamburger;
